import { actionTypes } from 'store/utils';

export const types = {
  ...actionTypes('GET_USER_DATA'),
  ...actionTypes('LOGOUT_USER'),
  ...actionTypes('GET_USER'),
  ...actionTypes('CHECK_USER'),
  ...actionTypes('GET_TAXIS_DATA'),
  RESET_USER: 'RESET_USER',
  CLEAR_USER: 'CLEAR_USER',
  REQUEST_PASSWORD_RESET: {
    START: 'REQUEST_PASSWORD_RESET_START',
    SUCCESS: 'REQUEST_PASSWORD_RESET_SUCCESS',
    ERROR: 'REQUEST_PASSWORD_RESET_ERROR',
  },
  UPDATE_USER: {
    START: 'UPDATE_USER_START',
    SUCCESS: 'UPDATE_USER_SUCCESS',
    ERROR: 'UPDATE_USER_ERROR',
  },
  LOGIN: {
    START: 'LOGIN_START',
    SUCCESS: 'LOGIN_SUCCESS',
    ERROR: 'LOGIN_ERROR',
  },
  GET_OAUTH2_CLIENTS: {
    START: 'GET_OAUTH2_CLIENTS_START',
    SUCCESS: 'GET_OAUTH2_CLIENTS_SUCCESS',
    ERROR: 'GET_OAUTH2_CLIENTS_ERROR',
  },
  SET_NEW_PASSWORD: {
    START: 'SET_NEW_PASSWORD_START',
    SUCCESS: 'SET_NEW_PASSWORD_SUCCESS',
    ERROR: 'SET_NEW_PASSWORD_ERROR',
  },
  REQUEST_TEMP_PASSWORD: {
    START: 'REQUEST_TEMP_PASSWORD_START',
    SUCCESS: 'REQUEST_TEMP_PASSWORD_SUCCESS',
    ERROR: 'REQUEST_TEMP_PASSWORD_ERROR',
  },
  CHECK_LOGIN: {
    START: 'CHECK_LOGIN_START',
    SUCCESS: 'CHECK_LOGIN_SUCCESS',
    ERROR: 'CHECK_LOGIN_ERROR',
  },
};